import axios from 'axios';
import handleError from 'services/handleError';
import { setUpdateStatusState } from '../redux/user-data/userDataSlice';
import { AI_PHOTOSHOOTING__BASE_PATH } from 'utils/configs';

const createTaskFromUploaded = async (toolPath, taskData, thunkAPI) => {
  const { getState, dispatch } = thunkAPI;
  const state = getState();
  const currentCreditNumber = state.userdata.credits;
  let urlEnding = `create-from-uploaded`;

  if (toolPath === AI_PHOTOSHOOTING__BASE_PATH) {
    urlEnding = `create`;
  }

  try {
    const { data } = await axios.post(
      `${toolPath}/task/${urlEnding}`,
      taskData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (data) {
      dispatch(
        setUpdateStatusState({
          creditsToCompare: currentCreditNumber,
          status: true,
        })
      );
    }

    return data;
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }

    const status = error.response?.status;
    const data = error.response?.data;

    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default createTaskFromUploaded;
